var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"skin-activity-artwork",style:(_vm.position),attrs:{"data-activity-art":_vm.name,"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }